import { Platform } from '../../../../../platform-call';
import { createAction } from '../../../../../store.model';
import { ActionType } from '../transcript-summary.action';

export interface DeleteTranscript {
    platform: Platform;
    transcriptId: number;
}

export const deleteTranscript = createAction<ActionType, DeleteTranscript>(
    ActionType.COACHING_DETAIL__TS__DELETE_TRANSCRIPT,
);

export interface DeleteTranscriptResult extends DeleteTranscript {}

export const deleteTranscriptResult = createAction<
    ActionType,
    DeleteTranscriptResult
>(ActionType.COACHING_DETAIL__TS__DELETE_TRANSCRIPT_RESULT);
